module.exports = __webpack_public_path__ + "static/img/0202_01.19ad799.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/0202_01.png
// module id = Hdgu
// module chunks = 1